module.exports = __webpack_public_path__ + "img/water8-2.77c9b74a.jpg";